module.exports = __webpack_public_path__ + "static/media/vod28.268087c8.png";